export const parseDataToColumns = (payload, t) => {
  const data = payload.reduce((acc, { name, groupTitle, groupType }) => {
    const _acc = { ...acc };
    if (_acc[groupType]) {
      _acc[groupType].items.push({
        name,
        hint: t(name),
      });
    } else {
      _acc[groupType] = {
        groupTitle,
        groupType,
        items: [
          {
            name,
            hint: t(name),
          },
        ],
      };
    }

    return _acc;
  }, {});

  return Object.values(data);
};
